<template>
  <div>
    <b-modal ref="my-modal" size="xl" hide-footer title="">
      <div class="d-block text-center">
        <!--        <h3>Hello From My Modal!</h3>-->
      </div>

      <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>
      <a role="button" class="btn btn-danger" @click="hideModal"><i class="fas fa-times-circle"></i></a>

      <h1>網頁文字</h1>

      <div style="display:none">{{SystemId}}</div>
      <MyCkEditor v-model="datas.HtmlContent" height="600px" width="800px"></MyCkEditor>
      <div v-if="ShowImages || ShowVideos || ShowCloud || ShowFiles || ShowFile">
        <h2>詳細</h2>
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1" v-if="ShowImages">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="info" style="text-align: left;">圖片</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <ListEditImage :mode="1" :datas="datas.Images" image-memo="(建議圖片大小:600x400)"></ListEditImage>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1" v-if="ShowVideos">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-3 variant="info" style="text-align: left;">影片</b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <ListEditVideo :datas="datas.Videos"></ListEditVideo>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1" v-if="ShowFiles">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-4 variant="info" style="text-align: left;">下載檔案</b-button>
            </b-card-header>
            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <ListEditFile :datas="datas.Files" :allow-single-file="false"></ListEditFile>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1" v-if="ShowFile">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-5 variant="info" style="text-align: left;">下載檔案</b-button>
            </b-card-header>
            <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <ListEditFile :datas="datas.Files" :allow-single-file="true"></ListEditFile>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1" v-if="ShowCloud">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-2 variant="info" style="text-align: left;">雲端相簿</b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                雲端相簿位置
                <input type="url" class="form-control" placeholder="" v-model="datas.CloudPhotoUrl">
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
<!--            <b-button class="mt-2" variant="btn btn-primary" block @click="submit()">儲存</b-button>-->
<!--      <b-button class="mt-3" variant="btn btn-danger" block @click="hideModal">關閉</b-button>-->
    </b-modal>

  </div>
</template>

<script>

/**

 **/

import ListEditImage from "./component/ListEditImage";
import ListEditVideo from "./component/ListEditVideo";
import ListEditFile from "./component/ListEditFile";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";

import {
  QueryType_Content,
  QueryType_Block,
} from "./js/rotaryDeclare";
import MyCkEditor from "@/views/taylorAdmin/component/MyCkEditor";

export default {
  components: {MyCkEditor, ListEditFile, ListEditVideo, ListEditImage},
  props: {
    SystemId: {
      type: String,
      required: true
    },
    ShowImages: {
      type: Boolean,
      default: true
    },
    ShowVideos: {
      type: Boolean,
      default: true
    },
    ShowCloud: {
      type: Boolean,
      default: true
    },
    ShowFiles: {
      type: Boolean,
      default: true
    },
    ShowFile: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{},
      datasTemplate:{
        HtmlContent:"",
        CloudPhotoUrl:"",
        Images:[],
        Videos:[],
        Files:[],
      },
      QueryType_Content:QueryType_Content,
      QueryType_Block:QueryType_Block,
    };
  },
  methods: {
    showModal() {
      this.loadData()
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    returnModal(value) {
      // this.$refs['my-modal'].toggle('#toggle-btn')

      // onePageUtil.webPartHtml_Save(this.areaId,this.blockId,this.formData.content)

      this.$emit('returnOk',value);
    },
    loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")
      // this.data=data
      this.loadDataByQueryType(this.QueryType_Block +"_"+ this.SystemId)

      // debugger // eslint-disable-line
    },
    loadDataByQueryType(queryType) {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;
      apiAdmin.api_getContent(queryType).then((data)=>{
        let dataApi=apiAdmin.initReturnString(data.data.data);

        if (dataApi===""){
          that.datas=JSON.parse(JSON.stringify(that.datasTemplate));
        }else{
          that.datas=dataApi;
        }
      })
    },
    submit(){
      // for (let i = 0; i < this.datas.Details.length; i++) {
      //   let item = this.datas.Details[i];
      //
      //   if (item.Year===""){
      //     util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
      //     return;
      //   }
      // }
      apiAdmin.api_saveContent(this.QueryType_Block +"_"+ this.SystemId,this.datas).then((data)=>{
        console.log(data);
        alert('儲存成功')
      })
    },
  },
  mounted() {
    // this.SystemId=this.$route.query.SystemId

  },
}
</script>


<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
}
</style>
